import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  notificationMessagesFeatureKey,
  NotificationMessagesPartialState,
  NotificationMessagesState,
  notificationsAdapter,
} from './notification-messages.reducer';
import { MessageEventType } from '@boma/shared/entities';
import { sortBy } from 'lodash';

export const getNotificationMessageState = createFeatureSelector<
  NotificationMessagesPartialState,
  NotificationMessagesState
>(notificationMessagesFeatureKey);

const { selectAll } = notificationsAdapter.getSelectors();

export const selectAllNotificationMessages = createSelector(
  getNotificationMessageState,
  (state: NotificationMessagesState) => selectAll(state)
);

export const selectLatestMessage = createSelector(
  getNotificationMessageState,
  (state: NotificationMessagesState) =>
    sortBy(selectAll(state), (value) => value.createdAt).reverse()[0]
);

export const selectUnreadMessages = createSelector(
  getNotificationMessageState,
  (state: NotificationMessagesState) =>
    selectAll(state).filter((message) =>
      message.messageEvents.every(
        (event) =>
          (event.messageEventType as any) !==
          MessageEventType[MessageEventType.Read]
      )
    )
);

export const getNextPage = createSelector(
  getNotificationMessageState,
  (state: NotificationMessagesState) => state.nextPage
);

export const selectAddingMessageEvents = createSelector(
  getNotificationMessageState,
  (state: NotificationMessagesState) => state.addingMessageEvents
);
